import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventFormSchemaServices } from "../../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyMedicalReviewServices } from "../../../../../APIServices/studyMedicalReviewServices";
import Swal from "sweetalert2";
import FormList from "../../../MedicalReview/ReviewSettings/FormList";

const MedicalReviewSetting = ({
  Show,
  Hide,
  Title,
  onMouseDown,
  tableRef,
  schemaId,
  subjectId,
  siteId
}) => {
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [reviewSettingForm, setReviewSettingForm] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventLoader, setEventLoader] = useState(false);
  const [formLoader, setFormtLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [reviewLoader, setReviewLoader] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getEventBasedonSchema = async () => {
    setEventLoader(true)
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, schemaId, "all")
    setEventList(data?.data || [])
    setEventLoader(false)
  }

  const getSchemaEventForms = async () => {
    setFormtLoader(true)
    let data = await studyEventManagementServices.getSchemaEventForms(studyId, schemaId, eventId, timePointId || "no", StudyMode)
    setFormList(data?.data || [])
    setFormtLoader(false)
  }

  const getSubjectMedicalReview = async () => {
    let data = await studyMedicalReviewServices.getSubjectMedicalReview(studyId, siteId, subjectId, schemaId, eventId, timePointId)
    setSelectedFormIds(data?.data || [])
    setReviewSettingForm(data?.reviewSettingForm || [])
  }

  const saveSubjectMedicalReview = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Save Change!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, save it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.siteId = siteId
        userData.subjectId = subjectId
        userData.schemaId = schemaId
        userData.eventId = eventId
        userData.timePointId = timePointId
        userData.forms = selectedFormIds
        userData.mode = StudyMode
        let data = await studyMedicalReviewServices.saveSubjectMedicalReview(userData);
        if (data?.statusCode === 200) {
          getSubjectMedicalReview();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    if (schemaId) {
      getEventBasedonSchema();
    }
  }, [schemaId]);

  useEffect(() => {
    if (eventId && schemaId) {
      getSchemaEventForms();
    }
    if (eventId && schemaId && subjectId && siteId) {
      getSubjectMedicalReview();
    }
  }, [eventId, siteId, schemaId, subjectId, timePointId]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 900 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <SplitPane
          split="vertical"
          minSize={"30%"}
          className="position-relative"
          style={{ height: "calc(100vh - 120px)" }}
        >
          {loading || eventLoader ? (
            <PageLoader />
          ) : eventList?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Please Select Schema."} />
            </div>
          ) : (
            <ListGroup className="p-2">
              {eventList?.map((event, index) => (
                <ListGroup.Item
                  action
                  title={event?.row?.EVENTID}
                  onClick={() => {
                    setEventId(event?.eventId);
                    setTimePointId(event?.row?.TIMEPOINTUNIQUEID);
                    setEventName(event?.row?.EVENTID);
                  }}
                  key={index}
                  style={{ padding: "7px 0px 7px 10px" }}
                  className={`hstack ${`${eventId}${timePointId || ""}` === `${event?.eventId}${event?.row?.TIMEPOINTUNIQUEID || ""}` ? "selectedMenu" : "bg-white"
                    }`}
                >
                  <span>{event?.row?.EVENTID} {event?.row?.TIMEPOINTID && `(${event?.row?.TIMEPOINTID})`}</span>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
          {formLoader ? (
            <PageLoader />
          ) : !eventId ? (
            <div className="hstack justify-content-center h-100">
              Click to view Form!
            </div>
          ) : (
            <FormList
              formList={formList}
              onMouseDown={onMouseDown}
              tableRef={tableRef}
              selectedFormIds={selectedFormIds}
              setSelectedFormIds={setSelectedFormIds}
              reviewSettingForm={reviewSettingForm}
            />
          )}
        </SplitPane>
      </Offcanvas.Body>
      <div className="p-2 bg-light border-top shadow-sm text-end">
        <button
          className={`updateProfile`}
          onClick={saveSubjectMedicalReview}
          disabled={buttonLoader || !studyId || !schemaId || !eventId}
          style={{ fontSize: 12 }}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" />
              Saving...
            </div>
          ) : (
            "Save Settings"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default MedicalReviewSetting;
